import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueVideoPlayer from 'vue-video-player';

// import { ActionBar, ActionBarIcon, ActionBarButton } from 'vant';

import {
    Button,
    Cell,
    Dialog,
    Popup,
    Col,
    Row,
    Form,
    Field,
    CellGroup,
    Area,
    Toast,
    Image as VanImage,
    Swipe,
    SwipeItem,
    Icon,
    Tab,
    Tabs,
    Space,
    Checkbox,
    CheckboxGroup,
    BackTop,
    Overlay,
    Search,
    Picker,
    RadioGroup,
    Radio,
    Cascader,
    Uploader,
    CountDown,
    Sticky,
    Loading,
    TreeSelect,
    NavBar,
    List,
    Grid,
    GridItem,
    ActionBar, ActionBarIcon, ActionBarButton, Badge, Switch
} from "vant";
import 'vant/lib/index.css';
import 'video.js/dist/video-js.css'
// import 'video.js/dist/video-js.css';
// import 'vue-video-player/src/custom-theme.css';
// const app = createApp(App);
// 在Vue实例外设置全局后置钩子
router.afterEach((to) => {
    // 设置标签页标题
    document.title = to.meta.title || '爱驿站';
});

createApp(App)
    .use(store)
    .use(router)
    .use(Button)
    .use(Cell)
    .use(Dialog)
    .use(Popup)
    .use(Col)
    .use(Row)
    .use(Form)
    .use(Field)
    .use(CellGroup)
    .use(Area)
    .use(Toast)
    .use(VanImage)
    .use(Swipe)
    .use(SwipeItem)
    .use(Icon)
    .use(Tab)
    .use(Tabs)
    .use(Space)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(BackTop)
    .use(Overlay)
    .use(Search)
    .use(Picker)
    .use(RadioGroup)
    .use(Radio)
    .use(Cascader)
    .use(Uploader)
    .use(CountDown)
    .use(Sticky)
    .use(Loading)
    .use(TreeSelect)
    .use(NavBar)
    .use(List)
    .use(Grid)
    .use(GridItem)
    .use(VueVideoPlayer)
    .use(ActionBar)
    .use(ActionBarIcon)
    .use(ActionBarButton)
    .use(Badge)
    .use(Switch)
    .mount('#app')
